/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AuditEvent,
    AuditEventFromJSON,
    AuditEventFromJSONTyped,
    AuditEventToJSON,
} from './AuditEvent';
import {
    QueryInfo,
    QueryInfoFromJSON,
    QueryInfoFromJSONTyped,
    QueryInfoToJSON,
} from './QueryInfo';

/**
 * 
 * @export
 * @interface AuditHistory
 */
export interface AuditHistory {
    /**
     * 
     * @type {Array<AuditEvent>}
     * @memberof AuditHistory
     */
    results: Array<AuditEvent>;
    /**
     * 
     * @type {QueryInfo}
     * @memberof AuditHistory
     */
    listResult?: QueryInfo;
    /**
     * Pagination token used in retrieving another page of items
     * @type {string}
     * @memberof AuditHistory
     */
    paginationToken?: string;
    /**
     * Whether there are more items in the next page
     * @type {boolean}
     * @memberof AuditHistory
     */
    hasNextPage?: boolean;
    /**
     * Whether there are more items in the previous page
     * @type {boolean}
     * @memberof AuditHistory
     */
    hasPreviousPage?: boolean;
}

export function AuditHistoryFromJSON(json: any): AuditHistory {
    return AuditHistoryFromJSONTyped(json, false);
}

export function AuditHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(AuditEventFromJSON)),
        'listResult': !exists(json, 'listResult') ? undefined : QueryInfoFromJSON(json['listResult']),
        'paginationToken': !exists(json, 'paginationToken') ? undefined : json['paginationToken'],
        'hasNextPage': !exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'hasPreviousPage': !exists(json, 'hasPreviousPage') ? undefined : json['hasPreviousPage'],
    };
}

export function AuditHistoryToJSON(value?: AuditHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(AuditEventToJSON)),
        'listResult': QueryInfoToJSON(value.listResult),
        'paginationToken': value.paginationToken,
        'hasNextPage': value.hasNextPage,
        'hasPreviousPage': value.hasPreviousPage,
    };
}

